<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">
        {{ $t("distributorcollectionreport") }}
      </div>

      <div class="mt-3 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getDistributorReportFromDate"
                  v-on:click="setDistributorDate(null, 'fromDate')"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  @selected="setDistributorDate($event, 'fromDate')"
                  :value="getDistributorReportFromDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getDistributorReportFromDate ? 'active' : ''"
                  >Show From Date</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getDistributorReportToDate"
                  v-on:click="setDistributorDate(null, 'toDate')"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  @selected="setDistributorDate($event, 'toDate')"
                  :value="getDistributorReportToDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <!-- disabled -->
                <label :class="getDistributorReportToDate ? 'active' : ''"
                  >Show To Date</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getDistributorReportSelectedCinema &&
                  getDistributorReportSelectedCinema.length > 0
                    ? 'shift-up'
                    : ''
                "
                >Select Cinema</label
              >
              <b-dropdown
                :text="getDistributorReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex + dropdownItem.cine_name"
                  @click="
                    onSelectCInemaNew({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div
            v-if="!getDistributorReportsIsDistributor"
            class="col-lg-6 col-xl-3 mb-4"
          >
            <div class="dropdown-curve-container mr-2">
              <!-- <label
                :class="getDistributorReportSelectedDistributor && getDistributorReportSelectedDistributor.length > 0 ? 'shift-up' : ''"
              >Select Distributor</label>
              <b-dropdown
                :text="getDistributorReportSelectedDistributor"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorReportDropdownList"
                  :key="dropdownIndex+dropdownItem.d_company_name"
                  @click="onDistributorReportDropdownHandler({ event: $event, name:'isDistributor',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.d_company_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="
                  getDistributorReportDropdownList.filter((d, index, array) => {
                    return this.MoviesList.map(m => m.d_id).includes(d.d_id);
                  })
                "
                :searchable="true"
                :placeholder="
                  getDistributorReportSelectedDistributor &&
                  getDistributorReportSelectedDistributor.length > 0 &&
                  is_distributor_selected
                    ? getDistributorReportSelectedDistributor
                    : 'Distributor'
                "
                label="d_company_name"
                track-by="d_id"
                @select="
                  distributorSelected({
                    event: $event,
                    name: 'isDistributor',
                    selectedItem: $event
                  })
                "
                :showLabels="false"
              >
              </multiselect>
              <div
                class="ml-2"
                style="color:red"
                @click="clearDistributorNew"
                v-if="
                  getDistributorReportSelectedDistributor &&
                    getDistributorReportSelectedDistributor.length > 0 &&
                    is_distributor_selected
                "
              >
              <u><a href="#" class="text-danger">clear</a></u>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 mb-4">
            <div class="dropdown-curve-container mr-2">
              <!-- <label
                :class="getDistributorReportSelectedMovie && getDistributorReportSelectedMovie.length > 0 ? 'shift-up' : ''"
              >Select Movie</label>
              <b-dropdown
                :text="getDistributorReportSelectedMovie"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorReportMoviesList"
                  :key="dropdownIndex+dropdownItem.movie_title"
                  @click="onDistributorReportDropdownHandler({ event: $event, name:'isMovie',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.movie_title }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                v-if="is_distributor_selected"
                :options="getDistributorReportMoviesList"
                :searchable="true"
                :placeholder="
                  getDistributorReportSelectedMovie &&
                  getDistributorReportSelectedMovie.length > 0
                    ? getDistributorReportSelectedMovie
                    : 'Movie'
                "
                label="movie_title"
                track-by="movie_id"
                @select="
                  onDistributorReportDropdownHandler({
                    event: $event,
                    name: 'isMovie',
                    selectedItem: $event
                  })
                "
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>

              <multiselect
                v-if="!is_distributor_selected"
                :options="MoviesList"
                :searchable="true"
                :placeholder="
                  getDistributorReportSelectedMovie &&
                  getDistributorReportSelectedMovie.length > 0
                    ? getDistributorReportSelectedMovie
                    : 'Movie'
                "
                label="movie_name"
                track-by="movie_id"
                @select="
                  onDistributorReportDropdownHandler({
                    event: $event,
                    name: 'isMovie',
                    selectedItem: $event,
                    movieList: ''
                  })
                "
                :allowEmpty="false"
                :showLabels="false"
              >
              </multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-4 p-0 m-0">
            <b-form-checkbox
              v-model="weekWithNoSchedule"
              class="j-checkbox pb-0"
              style="font-size: 13px"
              @change="
                onDistributorReportDropdownHandler({
                  event: $event,
                  name: 'weekWithNoSchedule'
                })
              "
            >
              <div class="text-capitalize">{{ $t("weekWithNoShow") }}</div>
            </b-form-checkbox>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <button
              class="btn btn-primary"
              @click.prevent.stop="fetchDistributorReportList"
            >
              {{ $tc("Fetch Report") }}
            </button>
          </div>

          <div
            v-if="
              getdistributorReportsListV2.FinalResult &&
                getdistributorReportsListV2.FinalResult.length > 0 &&
                (getDistributorPDFFileName || getDistributorExcelFileName)
            "
            class="col-lg-6 col-xl-3 align-self-center mb-4 d-flex justify-content-end align-items-center"
          >
            <div>Download as:</div>
            <a
              v-if="getDistributorPDFFileName"
              :href="BASE_URL + getDistributorPDFFileName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              v-if="getDistributorExcelFileName"
              :href="BASE_URL + getDistributorExcelFileName"
              target="_blank"
              title="Download as Excel"
              download
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
        </div>
      </div>

      <!-- getdistributorReportsListV2.FinalResult &&
            getdistributorReportsListV2.FinalResult.length === 0 -->
      <div class="swc-report" v-if="!getdistributorReportsListV2.FinalResult">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th class="text-left">Show Time and Class</th>
              <th>Screen Name</th>
              <th>Ticket Rate</th>
              <th>Ticket Sold</th>
              <th>Gross Book Office Revenue</th>
              <th>Offer Amount</th>
              <th>Service Charge</th>
              <th class="text-right">Net Collection</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="8">
                <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="
          getdistributorReportsListV2.FinalResult &&
            getdistributorReportsListV2.FinalResult.length > 0 &&
            !getIfNoDataInDateRange
        "
        v-for="(MainItem,
        MainItemIndex) in getdistributorReportsListV2.FinalResult"
        :key="MainItemIndex + MainItem.ss_actual_start_date"
        class="swc-report table-scroll"
      >
        <div class="d-flex mt-4 mb-2">
          <p class="mr-3 mb-0">
            <b>Date:</b> {{ MainItem.ss_actual_start_date | dateparse }}
          </p>
          <p class="mr-3 mb-0">
            <b>Week :</b>
            {{
              getWeekNumber(
                getReleaseDate,
                MainItem.ss_actual_start_date,
                getDistributorReportToDate,
                getWeekStartDay
              )
            }}
          </p>
          <p class="mr-3 mb-0">
            <b>Day :</b>
            <!-- {{ MainItem.ss_actual_start_date | daynumber }} -->
            {{ MainItem.ss_actual_start_date | getDay }}
          </p>
        </div>
        <!-- <p>
          <b>Date:</b> {{ MainItem.ss_actual_start_date | dateparse }} &nbsp;&nbsp;&nbsp;
           Week: {{ getWeekNumber(getReleaseDate,MainItem.ss_actual_start_date,getDistributorReportToDate,getWeekStartDay) }} &nbsp;&nbsp;&nbsp;
            Day: {{ MainItem.ss_actual_start_date | daynumber }}&nbsp;{{ MainItem.ss_actual_start_date | getDay }}</p> -->
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th class="text-left">Show Time and Class</th>
              <th>Screen Name</th>
              <th>Ticket Rate</th>
              <th>Ticket Sold</th>
              <th>Gross Book Office Revenue</th>
              <th>Offer Amount</th>
              <th
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{ DistributorReportCharge.ct_name }}
              </th>
              <!-- <th>CGST</th>
                <th>SGST</th>
                <th>Service Charge</th>
              <th>3D Charge</th>-->
              <th>Net Collection</th>
              <th class="text-right">Distributor Share</th>
            </tr>
          </thead>
          <tbody
            v-for="(DistributorReport,
            DistributorReportIndex) in MainItem.Shows"
            :key="DistributorReportIndex + 'Distributors'"
          >
            <tr
              v-for="(Show, ShowIndex) in DistributorReport.seat_types"
              :key="ShowIndex + Show.seat_type_name"
            >
              <td class="text-left">{{ Show.seat_type_name }}</td>
              <td class="text-left">{{ Show.screen_name }}</td>
              <td class="text-right">{{ currFormat(Show.rate) }}</td>
              <td class="text-right">
                {{ Show["tickets_sold"] ? Show["tickets_sold"] : 0 }}
              </td>
              <td class="text-right">
                {{
                  Show["gross_receipts"]
                    ? currFormat(Show["gross_receipts"])
                    : currFormat(0)
                }}
              </td>
              <td class="text-right">
                {{
                  Show["offer_price"]
                    ? currFormat(Show["offer_price"])
                    : currFormat(0)
                }}
              </td>
              <td
                class="text-right"
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{
                  Show[DistributorReportCharge.ct_name]
                    ? currFormat(Show[DistributorReportCharge.ct_name]) ||
                      currFormat(0)
                    : currFormat(0)
                }}
              </td>
              <td class="text-right">
                {{
                  Show["net_revenue2"]
                    ? currFormat(Show["net_revenue2"])
                    : currFormat(0)
                }}
              </td>
              <td class="text-right">
                {{ currFormat(Show["distributorShare"]) }}
              </td>
            </tr>

            <tr>
              <td class="text-left">
                <strong
                  >Show Time:
                  {{
                    DistributorReport.ss_start_show_time
                      ? DistributorReport.ss_start_show_time
                      : "-"
                  }}</strong
                >
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td class="text-right">
                <strong>{{
                  DistributorReport.seat_types.reduce(
                    (accumulator, { tickets_sold }) =>
                      accumulator + parseFloat(tickets_sold),
                    0
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    DistributorReport.seat_types.reduce(
                      (accumulator, { gross_receipts }) =>
                        accumulator + parseFloat(gross_receipts),
                      0
                    )
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    DistributorReport.seat_types.reduce(
                      (accumulator, { offer_price }) =>
                        accumulator + parseFloat(offer_price),
                      0
                    )
                  )
                }}</strong>
              </td>
              <td
                class="text-right"
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex +
                    DistributorReportCharge.ct_name +
                    DistributorReportCharge.ct_id
                "
              >
                <strong>
                  {{
                    currFormat(
                      DistributorReport.seat_types[0][
                        DistributorReportCharge.ct_name
                      ]
                    )
                  }}
                </strong>
              </td>

              <td class="text-right">
                <strong>{{
                  currFormat(
                    DistributorReport.seat_types.reduce(
                      (accumulator, { net_revenue2 }) =>
                        accumulator + parseFloat(net_revenue2),
                      0
                    )
                  )
                }}</strong>
              </td>

              <td class="text-right">
                <strong>{{
                  currFormat(
                    DistributorReport.seat_types.reduce(
                      (accumulator, { distributorShare }) =>
                        accumulator + parseFloat(distributorShare),
                      0
                    )
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <table class="swc-report-table align-first-left align-last-right " border="1">
          <tbody>
            <tr v-if="MainItem.TodaysTotal.length > 0">
              <td colspan="3" class="text-right">Today's Total :</td>

              <td>{{ MainItem.TodaysTotal[0].TicketSold }}</td>
              <td>{{ MainItem.TodaysTotal[0].GrossRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              <td
                v-for="(DistributorReportCharge, DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="DistributorReportChargeIndex+DistributorReportCharge.ct_name+DistributorReportCharge.charge_type_id+'One'"
              >{{ (MainItem.TodaysTotal[0][DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id]).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              <td>{{ MainItem.TodaysTotal[0].NetRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
            </tr>

            <tr v-if="MainItem.PreviousTotal.length > 0">
              <td colspan="3" class="text-right">Previous Total :</td>
              <td>{{ MainItem.PreviousTotal[0].TicketSold }}</td>
              <td>{{ MainItem.PreviousTotal[0].GrossRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              <td
                v-for="(DistributorReportCharge, DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="DistributorReportChargeIndex+DistributorReportCharge.ct_name+'TWO'"
              >{{ (MainItem.PreviousTotal[0][DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id]).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              <td>{{ MainItem.PreviousTotal[0].NetRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
            </tr>

            <tr v-if="MainItem.PreviousTotal.length > 0 || MainItem.TodaysTotal.length > 0">
              <td colspan="3" class="text-right">Grand Total :</td>
              <td>{{ MainItem.TodaysTotal[0].TicketSold + MainItem.PreviousTotal[0].TicketSold }}</td>
              <td>{{ (MainItem.TodaysTotal[0].GrossRevenue + MainItem.PreviousTotal[0].GrossRevenue).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              <td
                v-for="(DistributorReportCharge, DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="DistributorReportChargeIndex+DistributorReportCharge.ct_name+'THREE'"
              >{{ (MainItem.TodaysTotal[0][DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id] + MainItem.PreviousTotal[0][DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id]).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              <td>{{ (MainItem.TodaysTotal[0].NetRevenue + MainItem.PreviousTotal[0].NetRevenue).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
            </tr>
          </tbody>
        </table>-->

        <table
          v-if="
            getdistributorReportsListV2.DayWiseCollectionArr &&
              getdistributorReportsListV2.DayWiseCollectionArr.length > 0 &&
              MainItemIndex ==
                getdistributorReportsListV2.FinalResult.length - 1
          "
          class="swc-report-table  mt-4"
          border="1"
        >
          <thead>
            <tr class="bg-lightgrey">
              <td class="text-left">Day</td>
              <td>Shows</td>
              <td>Attendence</td>
              <td>Gross Revenue</td>
              <!-- <td>Housefull Nett</td> -->
              <th
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{ DistributorReportCharge.ct_name }}
              </th>
              <td>Total Tax</td>
              <td>Total Tax Distributor</td>
              <td>Nett</td>
              <!-- <td>%</td> -->
              <td class="text-right">Distributor Share</td>
            </tr>
          </thead>
          <tbody
            v-for="(Daysitem,
            DaysIndex) in getdistributorReportsListV2.DayWiseCollectionArr"
            :key="DaysIndex + Daysitem.date"
          >
            <tr v-if="DaysIndex <= MainItemIndex" class="text-right">
              <td class="text-left">{{ Daysitem.Day }}</td>
              <td>{{ Daysitem.Shows }}</td>
              <td>{{ Daysitem.Attendance }}</td>
              <td>{{ currFormat(Daysitem.gross_revenue) }}</td>
              <td
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{ currFormat(Daysitem[DistributorReportCharge.ct_name]) }}
              </td>
              <!-- <td>{{ currFormat(Daysitem.housefulNet) }}</td> -->
              <td>{{ currFormat(Daysitem.TotalTax) }}</td>
              <td>{{ currFormat(Daysitem.TotalDistributorTax) }}</td>
              <td>{{ currFormat(Daysitem.net_revenue2) }}</td>
              <!-- <td>
                {{
                  Daysitem.net_revenue == 0 || Daysitem.housefulNet == 0
                    ? 0
                    : currFormat(
                        (Daysitem.net_revenue / Daysitem.housefulNet) * 100
                      )
                }}
              </td> -->
              <td class="text-right">
                {{ currFormat(Daysitem.distributorShare) }}
              </td>
            </tr>
            <tr v-else class="text-right">
              <td class="text-left">{{ Daysitem.Day }}</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td class="text-right">&nbsp;</td>
            </tr>
          </tbody>
          <tbody
            v-if="
              MainItemIndex ==
                getdistributorReportsListV2.FinalResult.length - 1
            "
          >
            <tr class="text-right bg-lightgrey">
              <td class="text-left">Total :</td>
              <td>
                {{
                  getdistributorReportsListV2.FinalDayWiseCollectionSum.Shows
                }}
              </td>
              <td>
                {{
                  getdistributorReportsListV2.FinalDayWiseCollectionSum
                    .Attendance
                }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalDayWiseCollectionSum
                      .gross_revenue
                  )
                }}
              </td>
              <td
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalDayWiseCollectionSum[
                      DistributorReportCharge.ct_name
                    ]
                  )
                }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalDayWiseCollectionSum
                      .TotalTax
                  )
                }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalDayWiseCollectionSum
                      .TotalDistributorTax
                  )
                }}
              </td>
              <!-- <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalDayWiseCollectionSum
                      .housefulNet
                  )
                }}
              </td> -->
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalDayWiseCollectionSum
                      .net_revenue2
                  )
                }}
              </td>
              <!-- <td>
                {{
                  getdistributorReportsListV2.FinalDayWiseCollectionSum
                    .net_revenue == 0 ||
                  getdistributorReportsListV2.FinalDayWiseCollectionSum
                    .housefulNet == 0
                    ? 0
                    : currFormat(
                        (getdistributorReportsListV2.FinalDayWiseCollectionSum.net_revenue.toFixed(
                          2
                        ) /
                          getdistributorReportsListV2.FinalDayWiseCollectionSum.housefulNet.toFixed(
                            2
                          )) *
                          100
                      )
                }}
              </td> -->
              <td class="text-right">
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalDayWiseCollectionSum
                      .distributorShare
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>

        <table
          v-if="
            getdistributorReportsListV2.finalWeekArray &&
              getdistributorReportsListV2.finalWeekArray.length > 0 &&
              MainItemIndex ==
                getdistributorReportsListV2.FinalResult.length - 1
          "
          class="swc-report-table mt-4"
          border="1"
        >
          <thead>
            <tr class="bg-lightgrey">
              <td class="text-left">Week</td>
              <td>Shows</td>
              <td>Attendence</td>
              <td>Gross Revenue</td>
              <td
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{ DistributorReportCharge.ct_name }}
              </td>
              <td>Total Tax</td>
              <td>Total Distributor Tax</td>
              <td>Nett</td>
              <!-- <td>%</td> -->
              <td>Distributor Share</td>
              <th style="text-align: right;">Download</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="text-right"
              v-for="(CountItem,
              CountIndex) in getdistributorReportsListV2.finalWeekArray"
              :key="CountIndex + 'Count'"
            >
              <td class="text-left">{{ CountItem.name }}</td>
              <td>{{ CountItem.ShowsCount || CountItem.sum.Shows }}</td>
              <td>{{ CountItem.sum.Attendance }}</td>
              <td>{{ currFormat(CountItem.sum.gross_revenue) }}</td>
              <td
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{ currFormat(CountItem.sum[DistributorReportCharge.ct_name]) }}
              </td>
              <td>{{ currFormat(CountItem.sum.TotalTax) }}</td>
              <td>{{ currFormat(CountItem.sum.TotalDistributorTax) }}</td>
              <td>{{ currFormat(CountItem.sum.net_revenue2) }}</td>
              <!-- <td>
                {{
                  CountItem.sum.net_revenue == 0 ||
                  CountItem.sum.housefulNet == 0
                    ? 0
                    : currFormat(
                        (CountItem.sum.net_revenue.toFixed(this.MIN_FRACTION_DIGITS) /
                          CountItem.sum.housefulNet.toFixed(this.MIN_FRACTION_DIGITS)) *
                          100
                      )
                }}
              </td> -->
              <td>{{ currFormat(CountItem.sum.distributorShare) }}</td>
              <td style="text-align: right;">
                <a
                  :href="
                    BASE_URL +
                      '/api/admin/reports/daily/distributor_reports?distributor_id=' +
                      getDistributorReportSelectedDistributorId +
                      '&cinema_id=' +
                      getDistributorReportSelectedCinemaId +
                      '&md_id=' +
                      getDistributorReportSelectedMovieId +
                      '&fromDate=' +
                      CountItem.date[0] +
                      '&toDate=' +
                      CountItem.date[CountItem.date.length - 1] +
                      '&week=' +
                      CountItem.name.split(' ')[1]
                  "
                  target="_blank"
                  download
                  title="Download as PDF"
                >
                  <img
                    src="@/assets/img/icons/pdf-icon.svg"
                    height="25"
                    width="25"
                  />
                </a>
              </td>
            </tr>

            <tr class="bg-lightgrey text-right">
              <td class="text-left">Total :</td>
              <td>
                {{ getdistributorReportsListV2.FinalWeekCollection.Shows }}
              </td>
              <td>
                {{ getdistributorReportsListV2.FinalWeekCollection.Attendance }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection
                      .gross_revenue
                  )
                }}
              </td>
              <td
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection[
                      DistributorReportCharge.ct_name
                    ]
                  )
                }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection.TotalTax
                  )
                }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection
                      .TotalDistributorTax
                  )
                }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection.net_revenue2
                  )
                }}
              </td>
              <!-- <td>
                {{
                  getdistributorReportsListV2.FinalWeekCollection.net_revenue ==
                    0 ||
                  getdistributorReportsListV2.FinalWeekCollection.housefulNet ==
                    0
                    ? 0
                    : currFormat(
                        (getdistributorReportsListV2.FinalWeekCollection.net_revenue.toFixed(
                          2
                        ) /
                          getdistributorReportsListV2.FinalWeekCollection.housefulNet.toFixed(
                            2
                          )) *
                          100
                      )
                }}
              </td> -->
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection
                      .distributorShare
                  )
                }}
              </td>
              <td style="text-align: right;">
                <a @click="getWeekWisePdf()" title="Download as PDF">
                  <img
                    src="@/assets/img/icons/pdf-icon.svg"
                    height="25"
                    width="25"
                  />
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <table class="swc-report-table align-first-left align-last-right  mt-4" border="1">
          <thead>
            <tr class="bg-lightrey">
              <th :colspan="MainItem.distributorDeductions.length">Deductions (Rs.)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="MainItem.distributorDeductions.length > 0">
              <td
                v-for="(DeductionItem, DeductionIndex) in MainItem.distributorDeductions"
                :key="DeductionIndex+'MainDeduction'"
                class="p-0"
              >
                <table class="w-100">
                  <tr v-for="(Item, Index) in DeductionItem" :key="Index+Item.dd_deduction_label">
                    <td class="text-left">{{ Item.dd_deduction_label }} :</td>
                    <td class="text-left">{{ Item.dd_deduction_value }}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr v-if="MainItem.distributorDeductions.length === 0">
              <td class="p-0">No Distributor Deduction Found</td>
            </tr>
          </tbody>
          <tbody>
            <tr class="bg-lightgrey">
              <td :colspan="MainItem.distributorDeductions.length" class="p-0">
                <table class="w-100">
                  <tr>
                    <td
                      class="text-left"
                    >Total Nett: {{ (MainItem.TodaysTotal[0].NetRevenue + MainItem.PreviousTotal[0].NetRevenue).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
                    <td>Total Deductions: {{ MainItem.totalDeductions }}</td>
                    <td
                      class="text-right"
                    >{{ ((MainItem.TodaysTotal[0].NetRevenue + MainItem.PreviousTotal[0].NetRevenue) - MainItem.totalDeductions).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>-->
      </div>

      <div
        class="swc-report table-scroll"
        v-if="
          (getdistributorReportsListV2.FinalResult &&
            getdistributorReportsListV2.FinalResult.length === 0) ||
            getIfNoDataInDateRange
        "
      >
        <table
          v-if="
            getdistributorReportsListV2.finalWeekArray &&
              getdistributorReportsListV2.finalWeekArray.length > 0
          "
          class="swc-report-table mt-4"
          border="1"
        >
          <thead>
            <tr class="bg-lightgrey">
              <td class="text-left">Week</td>
              <td>Shows</td>
              <td>Attendence</td>
              <td>Gross Revenue</td>
              <td
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{ DistributorReportCharge.ct_name }}
              </td>
              <td>Total Tax</td>
              <td>Total Distributor Tax</td>
              <td>Nett</td>
              <!-- <td>%</td> -->
              <td>Distributor Share</td>
              <th style="text-align: right;">Download</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(CountItem,
              CountIndex) in getdistributorReportsListV2.finalWeekArray"
              :key="CountIndex + 'Count'"
            >
              <td class="text-left">{{ CountItem.name }}</td>
              <td>{{ CountItem.ShowsCount || CountItem.sum.Shows }}</td>
              <td>{{ CountItem.sum.Attendance }}</td>
              <td>{{ currFormat(CountItem.sum.gross_revenue) }}</td>
              <td
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{ currFormat(CountItem.sum[DistributorReportCharge.ct_name]) }}
              </td>
              <td>{{ currFormat(CountItem.sum.TotalTax) }}</td>
              <td>{{ currFormat(CountItem.sum.TotalDistributorTax) }}</td>
              <td>{{ currFormat(CountItem.sum.net_revenue2) }}</td>
              <!-- <td>
              {{
                CountItem.sum.net_revenue == 0 ||
                CountItem.sum.housefulNet == 0
                  ? 0
                  : currFormat(
                      (CountItem.sum.net_revenue.toFixed(this.MIN_FRACTION_DIGITS) /
                        CountItem.sum.housefulNet.toFixed(this.MIN_FRACTION_DIGITS)) *
                        100
                    )
              }}
            </td> -->
              <td>{{ currFormat(CountItem.sum.distributorShare) }}</td>
              <td style="text-align: right;">
                <a
                  :href="
                    BASE_URL +
                      '/api/admin/reports/daily/distributor_reports?distributor_id=' +
                      getDistributorReportSelectedDistributorId +
                      '&cinema_id=' +
                      getDistributorReportSelectedCinemaId +
                      '&md_id=' +
                      getDistributorReportSelectedMovieId +
                      '&fromDate=' +
                      CountItem.date[0] +
                      '&toDate=' +
                      CountItem.date[CountItem.date.length - 1] +
                      '&week=' +
                      CountItem.name.split(' ')[1]
                  "
                  target="_blank"
                  download
                  title="Download as PDF"
                >
                  <img
                    src="@/assets/img/icons/pdf-icon.svg"
                    height="25"
                    width="25"
                  />
                </a>
              </td>
            </tr>

            <tr class="bg-lightgrey">
              <td class="text-left">Total :</td>
              <td>
                {{ getdistributorReportsListV2.FinalWeekCollection.Shows }}
              </td>
              <td>
                {{ getdistributorReportsListV2.FinalWeekCollection.Attendance }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection
                      .gross_revenue
                  )
                }}
              </td>
              <td
                v-for="(DistributorReportCharge,
                DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="
                  DistributorReportChargeIndex + DistributorReportCharge.ct_name
                "
              >
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection[
                      DistributorReportCharge.ct_name
                    ]
                  )
                }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection.TotalTax
                  )
                }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection
                      .TotalDistributorTax
                  )
                }}
              </td>
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection.net_revenue2
                  )
                }}
              </td>
              <!-- <td>
              {{
                getdistributorReportsListV2.FinalWeekCollection.net_revenue ==
                  0 ||
                getdistributorReportsListV2.FinalWeekCollection.housefulNet ==
                  0
                  ? 0
                  : currFormat(
                      (getdistributorReportsListV2.FinalWeekCollection.net_revenue.toFixed(
                        2
                      ) /
                        getdistributorReportsListV2.FinalWeekCollection.housefulNet.toFixed(
                          2
                        )) *
                        100
                    )
              }}
            </td> -->
              <td>
                {{
                  currFormat(
                    getdistributorReportsListV2.FinalWeekCollection
                      .distributorShare
                  )
                }}
              </td>
              <td style="text-align: right;">
                <a @click="getWeekWisePdf()" title="Download as PDF">
                  <img
                    src="@/assets/img/icons/pdf-icon.svg"
                    height="25"
                    width="25"
                  />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="false" class="white-wrapper">
      <div class="bg-lightgrey font-weight-bold py-1 w-100 text-center">
        Collection Summary
      </div>

      <div class="swc-report mt-4">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th colspan="5">TODAY</th>
            </tr>
            <tr>
              <td class="text-left">Show</td>
              <td>Aud</td>
              <td>Nett</td>
              <td>BOR</td>
              <td class="text-right">%</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="text-left">9:05 AM</th>
              <td>61</td>
              <td>4341.84</td>
              <td>6,388.00</td>
              <td class="text-right">32.85</td>
            </tr>
            <tr>
              <th class="text-left"></th>
              <th>514</th>
              <th>54876.26</th>
              <th>77,142.00</th>
              <th class="text-right">30.80</th>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="swc-report mt-4">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th colspan="6">THIS WEEK</th>
            </tr>
            <tr>
              <td class="text-left">Day</td>
              <td>Sh.</td>
              <td>Aud</td>
              <td>Nett</td>
              <td>BOR</td>
              <td class="text-right">%</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="text-left">Fri</th>
              <td>9</td>
              <td>451</td>
              <td>68461.55</td>
              <td>91,886.00</td>
              <td class="text-right">27.00</td>
            </tr>
            <tr>
              <th class="text-left"></th>
              <th>93</th>
              <th>4652</th>
              <th>561,777.44</th>
              <th>774,952.00</th>
              <th class="text-right">38.70</th>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="swc-report mt-4">
        <table class="swc-report-table " border="1">
          <thead>
            <tr>
              <th colspan="5">THIS RUN (ALL SCREENS)</th>
            </tr>
            <tr>
              <td class="text-left">Wk</td>
              <td>Aud.</td>
              <td>Nett</td>
              <td>BOR</td>
              <td class="text-right">%</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="text-left">1</th>
              <td>4652</td>
              <td>561777.44</td>
              <td>774,952.00</td>
              <td class="text-right">38.70</td>
            </tr>
            <tr>
              <th class="text-left"></th>
              <th>4652</th>
              <th>561777.44</th>
              <th>774,952.00</th>
              <th class="text-right">38.70</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { movieWeekEnd } from "@/helper/collection";
import moment from "moment";
import MasterService from "@/services/MasterService";
import scheduleService from "@/services/scheduleService";

export default {
  data() {
    return {
      weekWithNoSchedule: false,
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: "",
      is_distributor_selected: false,
      MoviesList: [],
      CinemaID: "",

      selected_distributor: {}
    };
  },
  computed: {
    ...mapGetters([
      // GET LIST ONLY FROM MASTER STORE
      "getCinemasList",

      // Selected Dropdowns
      "getDistributorReportSelectedMovie",
      "getDistributorReportSelectedCinema",
      "getDistributorReportSelectedDistributor",
      // Flags
      "getDistributorReportsIsCinema",
      "getDistributorReportsIsDistributor",
      // Selected Dates
      "getDistributorReportToDate",
      "getDistributorReportFromDate",
      // Get List
      "getDistributorReportList",
      "getDistributorReportDropdownList",
      "getDistributorReportMoviesList",
      "getDistributorReportChargeList",
      "getdistributorReportsListV2",
      // GET EXCEL FILE
      "getDistributorExcelFileName",
      // PDF
      "getDistributorPDFFileName",

      // GET WEEK DATA
      "getDateWeekData",
      //
      "getReleaseDate",
      "getWeekStartDay",

      "getDistributorReportSelectedMovieId",
      "getDistributorReportSelectedDistributorId",
      "getDistributorReportSelectedCinemaId",
      "getIfNoDataInDateRange"
    ]),

    getStartDate() {
      let filterArray = [];
      filterArray = this.getdistributorReportsListV2.finalWeekArray.filter(
        x => x.sum.Shows > 0
      );
      if (filterArray.length > 0) {
        return filterArray[0].date[0];
      } else {
        return moment().format("YYYY-MM-DD");
      }
    },

    getEndDate() {
      let filterArray = [];
      filterArray = this.getdistributorReportsListV2.finalWeekArray.filter(
        x => x.sum.Shows > 0
      );
      if (filterArray.length > 0) {
        let lastElement = filterArray.pop();
        return lastElement.date[lastElement.date.length - 1];
      } else {
        return moment().format("YYYY-MM-DD");
      }
    },
    getArrayOfWeekCollection() {
      let filterArray = [];
      let TempArray = [];
      filterArray = this.getdistributorReportsListV2.finalWeekArray.filter(
        x => x //.sum.Shows > 0
      );
      if (filterArray.length > 0) {
        filterArray.map(x => {
          let obj = {
            distributor_id: this.getDistributorReportSelectedDistributorId,
            cinema_id: this.getDistributorReportSelectedCinemaId,
            md_id: this.getDistributorReportSelectedMovieId,
            fromDate: x.date[0],
            toDate: x.date[x.date.length - 1],
            week: x.name.split(" ")[1]
          };
          TempArray.push(obj);
        });
      }
      return TempArray;
    }
  },
  beforeMount() {
    // console.log(
    //   "movieWeekEnd :",
    //   movieWeekEnd(new Date("2020-02-23T17:10:05+05:30"))
    // );
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let distributorId = this.secureStore.get("USINFO")["distributor_id"];
    console.log("dis::::::::::::: :", distributorId);
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onDistributorReportDropdownHandler({
        event: null,
        name: "isCinema",
        selectedItem: CinemaObj
      });
    }
    console.log("CinemaObj", CinemaObj, cinemaId);
    if (cinemaId || CinemaObj) {
      let cinema_id_newww = cinemaId
        ? cinemaId
        : CinemaObj.cine_id
        ? CinemaObj.cine_id
        : null;
      if (cinema_id_newww) {
        console.log("cinema_id_newww", cinema_id_newww, cinemaId);
        this.getAllActiveMovies(cinema_id_newww);
      }
    }

    // this.onDistributorReportFlagHandler({
    //   event: null,
    //   name: "isCinema",
    //   value: cinemaId
    // });
    if (distributorId) {
      this.onDistributorReportFlagHandler({
        event: null,
        name: "isDistributor",
        value: distributorId
      });
    }
    // this.onDistributorReportFlagHandler({
    //   event: null,
    //   name: "isCountry",
    //   value: this.secureStore.get("BRGLOPCO") || null
    // });
    // this.fetchCinemasList({ cinemaId });
    this.fetchReportDistributorsList();
    // this.fetchDistributorsActiveMasterMovie();
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        console.log("asdasdasdasdasdasd", CinemaObj);
        this.onDistributorReportDropdownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj
        });
        this.getAllActiveMovies(CinemaObj.cine_id);
      }
    }
  },
  mounted() {},
  methods: {
    setDistributorDate(event, date_type) {
      this.onDistributorReportDateHandler({
        event: event,
        name: date_type
      });
      this.getAllActiveMovies(this.CinemaID);
      if (this.is_distributor_selected) {
        this.distributorSelected(this.selected_distributor);
      }
    },

    clearDistributorNew() {
      this.is_distributor_selected = false;
      this.$store.dispatch("clearDistributor", null);
    },
    onSelectCInemaNew(selected_cinema_payload) {
      console.log("dasfsafsfsf");
      this.onDistributorReportDropdownHandler(selected_cinema_payload);
      this.getAllActiveMovies(selected_cinema_payload.selectedItem.cine_id);
    },
    getAllActiveMovies: function(cinema_id) {
      this.CinemaID = cinema_id;
      let loader = this.$loading.show();

      scheduleService
        .GetMoviesDDwithtransactiondate({
          title: "",
          tab: "Recent",
          cinema_id,
          fromDate: this.getDistributorReportFromDate
            ? moment(this.getDistributorReportFromDate).format("YYYY-MM-DD")
            : "",
          toDate: this.getDistributorReportToDate
            ? moment(this.getDistributorReportToDate).format("YYYY-MM-DD")
            : "",
          filter_with_key: "ss_actual_start_date"
          // toDate
        })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.MovieListResult.length > 0) {
            this.MoviesList = data.MovieListResult.filter(x => {
              x["movie_name"] = `${x["movie_name"]} (${x["d_company_name"]})`;
              return !x.parent_movie_id;
            });
            loader.hide();
          } else {
            this.MoviesList = [];
            loader.hide();

            // Show Message Here:
            // console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
        })
        .finally(() => {});
    },
    distributorSelected(selected_payload) {
      this.is_distributor_selected = true;
      this.selected_distributor = selected_payload;
      this.onDistributorReportDropdownHandler(selected_payload);
    },
    getWeekWisePdf() {
      let loader = "";
      let payload = {
        Collections: this.getArrayOfWeekCollection
      };
      loader = this.$loading.show();
      MasterService.GetWeekWisePdf(payload)
        .then(response => {
          console.log("response", response);
          const { data } = response;
          if (response.data.status) {
            console.log({ "data.url": data.url });
            window.location = data.url;
          }
        })
        .catch(err => {
          console.log("Error: ", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    onSelectCinema(cinema, fromDate) {
      console.log("fsfsdfsd", cinema.cine_id);
      this.getAllActiveMovies(cinema.cine_id);

      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };
                console.log("COming Hereee");
                // this.onSelectCinema(null,cinema);
                this.onDistributorReportFlagHandler({
                  event: null,
                  name: "isCinema",
                  value: x.cine_id,
                  cine_name: x.cine_name
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      // "fetchDistributorsList",
      // "fetchDistributorsActiveMasterMovie",
      // FETCH LIST ONLY
      "fetchReportDistributorsList",
      "fetchDistributorReportList",
      "onDistributorReportDateHandler",
      "onDistributorReportDropdownHandler",
      "onDistributorReportFlagHandler",
      "onResetDistributorStoreState"
    ]),
    getWeekNumber: function(release_date, show_date, endDate, WeekStartDay) {
      let weekDay = this.getdistributorReportsListV2.finalWeekArray.filter(
        x => {
          return x.date.indexOf(moment(show_date).format("YYYY-MM-DD")) >= 0;
        }
      );
      console.log(weekDay, "Weeeed");
      return weekDay[0].name;
      // console.log("release_date :>> ", release_date);
      // console.log("show_date :>> ", show_date);
      // console.log("endDate :>> ", endDate);
      // let ReleaseDate = moment(moment(release_date).format("YYYY-MM-DD"));
      // let startDate = moment(moment(release_date).format("YYYY-MM-DD"));
      // let ShowDate = moment(moment(show_date).format("YYYY-MM-DD"));
      // let EndDate = moment(moment(endDate).format("YYYY-MM-DD"));
      // let CountWeek = 1;
      // while (startDate.isSameOrBefore(EndDate)) {
      //   if (ReleaseDate.isAfter(ShowDate)) {
      //     return 0;
      //   }
      //   if (startDate.isSame(ShowDate)) {
      //     return CountWeek;
      //   }
      //   let d = startDate;
      //   if (moment(d).format("dddd") === WeekStartDay) {
      //     CountWeek += 1;
      //   }
      //   startDate.add(1, "days");
      // }
      return CountWeek;
    }
  },
  beforeDestroy: async function() {
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDistributorExcelFileName
    });
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDistributorPDFFileName
    });
    await this.onResetDistributorStoreState();
  }
};
</script>

<style>
/* .align-last-center tr > th:last-child,
tr > td:last-child {
  text-align: center;
}

.align-first-left tr > th:first-child,
tr > td:first-child {
  text-align: left;
  padding-left: 2px;
}

.align-last-right tr > th:last-child,
tr > td:last-child {
  text-align: right;
  padding-right: 2px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/distributorCollectionReportV2.vue